// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useTranslation } from 'react-i18next';
import { useExpanded } from '@shared/ui-kit/hooks';
import { type AdvisoryBank } from '@shared/data-access/types/brokerage-types';
import { selectAccountCurrency } from '@shared/data-access/slices/user';
import { useSelector } from 'react-redux';
import { NUVARA_INVERSIS_INSTITUTION_ID } from '@shared/data-access/utils';
import type { BankAccountUnsharePayload } from './use-bank-accounts';

export interface BanksListProps {
  readonly banks: AdvisoryBank[];
  readonly onAccountClick?: (institution: string, iban: string) => void;
  readonly onSyncClick?: (id: string) => void;
  readonly onRefreshBank?: (id: string, name: string) => void;
  readonly onRemoveBank?: (id: string, name: string) => void;
  readonly onUnshareAccount?: (sharedAccount: BankAccountUnsharePayload) => void;
}

export const useBanksList = (props: BanksListProps) => {
  const { t } = useTranslation();
  const currency = useSelector(selectAccountCurrency);
  const { isExpanded, getToggleHandler } = useExpanded<string>([
    NUVARA_INVERSIS_INSTITUTION_ID,
  ]);

  return {
    t,
    currency,
    isExpanded,
    getToggleHandler,
  } as const;
};
